const ReasonType = (id, name) => {
    return {
        id,
        name
    }
}

export default ReasonType;